module.exports = __webpack_public_path__ + "static/media/7yw_fr.a4cf7973.svg";